import { NavLink } from "react-router-dom";

import {
  FaCogs,
  FaEnvelope,
  FaGraduationCap,
  FaHome,
  FaInfoCircle,
  FaPaperPlane,
  FaProjectDiagram
} from "react-icons/fa";

function Navbar() {
  return (
    <nav className="navbar">

      {/* Logo */}
      <div className="logo">
        <span>Nason's Tech</span>
        <small>Automation & IT Solutions</small>
      </div>

      {/* Navigation Links */}
      <div className="nav-links">

        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          <FaHome  style={{marginRight:"7px"}} className="nav-icon" />
          <span>Home</span>
        </NavLink>

        <NavLink
          to="/about"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          <FaInfoCircle style={{marginRight:"7px"}}  className="nav-icon" />
          <span>About</span>
        </NavLink>

        <NavLink
          to="/service"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          <FaCogs  style={{marginRight:"7px"}} className="nav-icon" />
          <span>Services</span>
        </NavLink>

        <NavLink
          to="/training"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          <FaGraduationCap  style={{marginRight:"7px"}} className="nav-icon" />
          <span>Training</span>
        </NavLink>

        <NavLink
          to="/project"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          <FaProjectDiagram style={{marginRight:"7px"}} className="nav-icon" />
          <span>Projects</span>
        </NavLink>

        <NavLink
          to="/contact"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          <FaEnvelope  style={{marginRight:"7px"}} className="nav-icon" />
          <span>Contact</span>
        </NavLink>

      </div>

      {/* Enquire Button */}
      <NavLink
        to="/contact"
        className="nav-button"
      >
        <FaPaperPlane style={{marginRight:"7px"}} className="button-icon" />
        <span>Enquire Now</span>
      </NavLink>

    </nav>
  );
}

export default Navbar;